import { Config } from "../../../configurations/config";
export const MonthlyTimesheet_API = {
  GetMonthlyTimesheetList: `${Config.server_url}${Config.api_prefix}/TimeSheet/MonthlyTimesheet?`,
  GetSupervisorsEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsEmployeesList`,
  SendMonthlyTimesheetEmail: `${Config.server_url}${Config.api_prefix}/TimeSheet/MonthlyTimesheet/SendEmail?`,
  ExportToExcel: `${Config.server_url}${Config.api_prefix}/TimeSheet/MonthlyTimesheet/ExportToExcel`,
  PostMonthlyTimesheetList: `${Config.server_url}${Config.api_prefix}/TimeSheet/MonthlyTimesheet`,
  GetEmployeeList: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees`,
};
